// extracted by mini-css-extract-plugin
export default {"Frozen":"EditLayoutTab_Frozen__nRFkA","numberInput":"EditLayoutTab_numberInput__GDgan"};